import { t } from '@base/utils/helpers';
import React, { useState } from 'react';
import { container } from 'tsyringe';
import { IUserService } from '@base/features/user/model/interfaces';
import styles from '@base/features/user/styles/info.module.scss';
import InfoItem from '@base/features/user/components/infoItem';
import Empty from '@ui-kit/components/empty';
import { objectKeys } from '@utils/functions';
import { gender } from '@base/utils/gender';
import { Checkbox } from '@ui-kit/components/checkbox';
import { maritalStatus } from '@base/utils/maritalStatus';
import Flag from '@ui-kit/components/flag';
import { useAsyncData } from '@utils/hooks';
import { Loader } from '@ui-kit/components/loader';

export default function UserGeneralInfo() {
  const userService: IUserService = container.resolve('userService');
  const { data: personalInfo, loading: dataLoading, setData: setPersonalInfo } = useAsyncData(() => userService.getUserInfo());
  const [loading, setLoading] = useState(false);

  if (dataLoading) return <div><Loader /></div>;
  if (!personalInfo) return <Empty>No personal info</Empty>;

  const info = {
    first_name: personalInfo.real_name.first_name,
    login: personalInfo.login_name,
    last_name: personalInfo.real_name.last_name,
    country: personalInfo.address.country,
    birthday: personalInfo.yob?.toString(),
    city: personalInfo.address.city,
    gender: personalInfo.gender ? gender.value(personalInfo.gender) : '',
    email: personalInfo.email,
    status: personalInfo.marital_status ? maritalStatus.value(personalInfo.marital_status) : '',
    phone: personalInfo.phone,
    about: personalInfo.about,
  };

  const handlerSubscribe = async () => {
    setLoading(true);
    if (personalInfo.subscriber === 'Y') {
      await userService.unsubscribeAnnoucements();
    }
    if (personalInfo.subscriber === 'N') {
      await userService.subscribeAnnoucements();
    }
    const newInfo = await userService.getUserInfo();
    setPersonalInfo(newInfo);
    setLoading(false);
  };

  return (
    <div className={styles.info}>
      <div className={styles.list}>
        {objectKeys(info).map((key) => (
          <InfoItem title={key} key={key}>
            {key === 'country' && (
              <Flag style={{ marginRight: '.8rem' }} countryCode={personalInfo.address.country_code} />
            )}
            {info[key]}
          </InfoItem>
        ))}
      </div>
      <div className={styles.unsubscribe}>
        <Checkbox
          id="subscribe"
          checked={personalInfo.subscriber === 'Y'}
          name="subscribe"
          loading={loading}
          handler={handlerSubscribe}
        >
          {personalInfo.subscriber === 'Y' ? t('unsubscribe_annoucements') : t('subscribe_annoucements')}
        </Checkbox>
      </div>
    </div>
  );
}
